<template>
  <svg
    class="text-primary"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.5C18.299 23.5 23 18.799 23 13C23 7.20101 18.299 2.5 12.5 2.5C6.70101 2.5 2 7.20101 2 13C2 18.799 6.70101 23.5 12.5 23.5ZM12.0737 18.0396L17.8419 9.0396L16.1581 7.9604L11.0647 15.9076L8.71154 13.5246L7.28846 14.9299L10.5203 18.2026L11.399 19.0924L12.0737 18.0396Z"
      fill="currentColor"
    />
  </svg>
</template>
